import React from 'react';
import ReactDOM from 'react-dom/client';
import './lib/axios'; // Configure axios with cookies support first
import { initializeAnalytics } from './services/analytics';
import App from './App';
import './main.css';

// Initialize Google Analytics 4
initializeAnalytics();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
